
import Navbar from '../../components/feature/Navbar';
import HeroSection from './components/HeroSection';
import SavingsCalculator from './components/SavingsCalculator';
import ProcessSection from './components/ProcessSection';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroSection />
      <SavingsCalculator />
      <ProcessSection />
    </div>
  );
}
